;
var sprite = require("/tmp/build_28b142ae/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Previous_0709d8c0d187f59a08258ae3fcd02b4b\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M59.312,16.187l3.017,3.016L31.482,50.049l30.75,30.748l-3.018,3.016L25.45,50.049L59.312,16.187z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Previous_0709d8c0d187f59a08258ae3fcd02b4b");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Previous.svg
// module id = 1411
// module chunks = 0